<template>
  <div class="kb_wrap">
    <!-- 左侧：知识库列表 -->
    <div class="kb_side" v-loading="kbLoading">
      <div class="kb_side_head">
        <span class="kb_side_title">知识库</span>
        <el-button type="primary" size="mini" icon="el-icon-plus" @click="openKbAdd">新建</el-button>
      </div>
      <div class="kb_list">
        <div v-for="kb in kbList" :key="kb.kb_id" class="kb_item"
             :class="{ active: currentKbId === kb.kb_id }" @click="selectKb(kb)">
          <div class="kb_item_body">
            <div class="kb_item_name" :title="kb.name">{{ kb.name }}</div>
            <div class="kb_item_desc" :title="kb.description">{{ kb.description || '暂无描述' }}</div>
          </div>
          <div class="kb_item_ops" @click.stop>
            <i class="el-icon-link" title="绑定数字员工" @click="openKbBind(kb)"></i>
            <i class="el-icon-edit-outline" title="编辑" @click="openKbEdit(kb)"></i>
            <i class="el-icon-delete" title="删除" @click="handleKbDel(kb)"></i>
          </div>
        </div>
        <div v-if="!kbList.length && !kbLoading" class="kb_empty">暂无知识库，点击右上角新建</div>
      </div>
    </div>

    <!-- 右侧：文档管理 -->
    <div class="kb_main">
      <div v-if="!currentKbId" class="kb_placeholder">
        <i class="el-icon-collection"></i>
        <p>请选择左侧知识库后管理文档</p>
      </div>
      <template v-else>
        <div class="toolbar">
          <el-form :inline="true" :model="queryForm" class="query_form" @submit.native.prevent>
            <el-form-item label="标题">
              <el-input v-model="queryForm.title" placeholder="标题模糊搜索" clearable
                        style="width: 160px" @keyup.enter.native="onSearch" />
            </el-form-item>
            <el-form-item label="状态">
              <el-select v-model="queryForm.status" placeholder="全部" clearable style="width: 120px">
                <el-option v-for="(text, key) in statusFilter" :key="key" :label="text" :value="key" />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSearch">查询</el-button>
              <el-button @click="resetQuery">重置</el-button>
            </el-form-item>
          </el-form>
          <div>
            <el-button type="primary" icon="el-icon-upload2" :loading="uploading" @click="chooseFile">上传文档</el-button>
            <el-button icon="el-icon-search" @click="searchVisible = true">检索测试</el-button>
            <el-button icon="el-icon-refresh" plain @click="handleKbRevector">整库重向量化</el-button>
          </div>
        </div>

        <el-table :data="tableData" v-loading="loading" border>
          <el-table-column label="标题" min-width="160" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.title || scope.row.filename }}</template>
          </el-table-column>
          <el-table-column label="大小" width="90">
            <template slot-scope="scope">{{ fmtSize(scope.row.size) }}</template>
          </el-table-column>
          <el-table-column label="状态" width="180">
            <template slot-scope="scope">
              <el-tag :type="statusTagType(scope.row)" size="small" :title="scope.row.error || ''">
                {{ statusText(scope.row.status) }}
              </el-tag>
              <el-tag v-if="needRevector(scope.row)" type="info" size="mini" class="dirty_tag">待重向量化</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="摘要" min-width="200" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.summary || '-' }}</template>
          </el-table-column>
          <el-table-column label="上传时间" width="160">
            <template slot-scope="scope">{{ fmtTime(scope.row.ctime) }}</template>
          </el-table-column>
          <el-table-column label="操作" width="250" fixed="right">
            <template slot-scope="scope">
              <el-button v-if="scope.row.status === 'failed'" type="text" size="small" @click="handleRetry(scope.row)">重试</el-button>
              <el-button v-if="scope.row.status === 'done'" type="text" size="small"
                         :loading="scope.row.revectoring" @click="handleRevector(scope.row)">重新向量化</el-button>
              <el-button v-if="(scope.row.discovered_skills || []).length" type="text" size="small"
                         @click="openDiscovery(scope.row)">发现({{ scope.row.discovered_skills.length }})</el-button>
              <el-button type="text" size="small" class="danger_text" @click="handleDocDel(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pagesize"
          background
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        />
      </template>
    </div>

    <input ref="fileInput" type="file" class="kb_file_input" :accept="acceptExts" @change="handleFileChange" />

    <el-dialog :title="kbIsEdit ? '编辑知识库' : '新建知识库'" :visible.sync="kbDialogVisible"
               width="480px" v-dialogDrag :modal-append-to-body="false" v-if="kbDialogVisible">
      <el-form ref="kbForm" :model="kbForm" :rules="kbRules" label-width="70px" @submit.native.prevent>
        <el-form-item label="名称" prop="name">
          <el-input v-model="kbForm.name" maxlength="64" placeholder="同账号下唯一" />
        </el-form-item>
        <el-form-item label="描述">
          <el-input v-model="kbForm.description" type="textarea" :rows="3" maxlength="200" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="kbDialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="kbSubmiting" @click="submitKbForm">确 定</el-button>
      </div>
    </el-dialog>

    <kb-search :visible.sync="searchVisible" :kb="currentKb" />
    <kb-discovery :visible.sync="discoveryVisible" :doc="discoveryDoc" @refresh="loadDocs(true)" />
    <kb-bindings :visible.sync="bindVisible" :kb-id="bindKb ? bindKb.kb_id : ''" :kb-name="bindKb ? bindKb.name : ''" />
  </div>
</template>

<script>
import { agentBody, isAdminAcc } from '../utils'
import KbSearch from './search.vue'
import KbDiscovery from './discovery.vue'
import KbBindings from './bindings.vue'

// 流水线状态中文映射（中间态兜底显示原值）；终态仅 done/failed
const DOC_STATUS_TEXT = {
  queued: '排队中', parsing: '解析中', normalizing: '规范化', documenting: '文档化',
  bucketing: '分桶中', bucket_writing: '写入桶', chunking: '分块中', embedding: '向量化',
  summarizing: '生成摘要', discovering: '知识发现', done: '已完成', failed: '失败'
}
const FINAL_STATUS = ['done', 'failed']
const UPLOAD_EXTS = ['.txt', '.md', '.html', '.htm', '.pdf', '.docx']
const MAX_UPLOAD_SIZE = 20 * 1024 * 1024

// 知识库管理：左侧库列表 + 右侧文档表格（上传/轮询/重试/重向量化）
export default {
  name: 'AiAgentKnowledge',
  components: { KbSearch, KbDiscovery, KbBindings },
  data() {
    return {
      kbList: [],
      kbLoading: false,
      currentKbId: '',
      queryForm: { title: '', status: '' },
      tableData: [],
      loading: false,
      currentPage: 1,
      pagesize: 20,
      total: 0,
      uploading: false,
      pollTimer: null,
      docReqSeq: 0,
      kbDialogVisible: false,
      kbIsEdit: false,
      kbSubmiting: false,
      kbForm: { kb_id: '', name: '', description: '' },
      kbRules: {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }]
      },
      searchVisible: false,
      discoveryVisible: false,
      discoveryDoc: null,
      bindVisible: false,
      bindKb: null,
      statusFilter: { queued: '排队中', parsing: '解析中', done: '已完成', failed: '失败' },
      acceptExts: UPLOAD_EXTS.join(',')
    }
  },
  computed: {
    currentKb() {
      return this.kbList.find(k => k.kb_id === this.currentKbId) || null
    }
  },
  mounted() {
    // 管理员无 owner，常驻挂载下发 owner 型请求会 1002 弹错，跳过自动加载
    if (isAdminAcc()) return
    this.loadKbs()
  },
  beforeDestroy() {
    this._kbDead = true // 阻止 in-flight 响应回调重启轮询
    this.stopPolling()
  },
  methods: {
    // ===== 知识库 =====
    loadKbs(preferredId) {
      this.kbLoading = true
      this.$tools.asyncPost(this, this.$baseUrl.aiAgentKbBasesList,
        agentBody({ page: 1, limit: 100 })).then((res) => {
        if (res.data.code == 0) {
          this.kbList = res.data.data.data || []
          // 优先选指定库（新建后定位），否则当前选中失效/首次进入时默认第一个
          let next = ''
          if (preferredId && this.kbList.some(k => k.kb_id === preferredId)) next = preferredId
          else if (this.kbList.length && !this.kbList.some(k => k.kb_id === this.currentKbId)) next = this.kbList[0].kb_id
          if (next && next !== this.currentKbId) this.selectKb({ kb_id: next })
        }
        this.kbLoading = false
      }).catch(() => { this.kbLoading = false })
    },
    selectKb(kb) {
      if (this.currentKbId === kb.kb_id) return
      this.currentKbId = kb.kb_id
      this.currentPage = 1
      this.queryForm = { title: '', status: '' }
      this.stopPolling()
      this.loadDocs()
    },
    openKbAdd() {
      this.kbForm = { kb_id: '', name: '', description: '' }
      this.kbIsEdit = false
      this.kbDialogVisible = true
      this.$nextTick(() => this.$refs.kbForm && this.$refs.kbForm.clearValidate())
    },
    openKbBind(kb) {
      this.bindKb = kb
      this.bindVisible = true
    },
    openKbEdit(kb) {
      // bases/list 返回 AiKnowledgeBase 全量字段，行数据直接回填
      this.kbForm = { kb_id: kb.kb_id, name: kb.name, description: kb.description || '' }
      this.kbIsEdit = true
      this.kbDialogVisible = true
      this.$nextTick(() => this.$refs.kbForm && this.$refs.kbForm.clearValidate())
    },
    submitKbForm() {
      this.$refs.kbForm.validate((valid) => {
        if (!valid) return
        this.kbSubmiting = true
        const payload = { name: this.kbForm.name, description: this.kbForm.description }
        if (this.kbIsEdit) payload.kb_id = this.kbForm.kb_id
        const url = this.kbIsEdit ? this.$baseUrl.aiAgentKbBasesEdit : this.$baseUrl.aiAgentKbBasesAdd
        this.$tools.asyncPost(this, url, agentBody(payload)).then((res) => {
          if (res.data.code == 0) {
            this.$message({ type: 'success', message: res.data.msg || '操作成功' })
            this.kbDialogVisible = false
            // 新建后自动选中新库（add 响应 data.id），编辑保持当前选中
            this.loadKbs(this.kbIsEdit ? '' : (res.data.data && res.data.data.id))
          }
          this.kbSubmiting = false
        }).catch((err) => {
          this.kbSubmiting = false
          if (err && err.isAxiosError) this.$message({ type: 'error', message: '请求失败，请稍后重试' })
        })
      })
    },
    handleKbDel(kb) {
      this.$MessageBox.confirm('删除后不可恢复；库内仍有文档时将被拒绝，需先清空文档。确认删除该知识库？', '提示', { type: 'warning' }).then(() => {
        this.$tools.asyncPost(this, this.$baseUrl.aiAgentKbBasesDel,
          agentBody({ id: kb.kb_id })).then((res) => {
          if (res.data.code == 0) {
            this.$message({ type: 'success', message: '删除成功' })
            if (this.currentKbId === kb.kb_id) {
              this.stopPolling()
              this.tableData = []
              this.total = 0
            }
            this.loadKbs()
          }
        }).catch((err) => {
          if (err && err.isAxiosError) this.$message({ type: 'error', message: '请求失败，请稍后重试' })
        })
      }).catch(() => {})
    },
    handleKbRevector() {
      this.$MessageBox.confirm('将对库内所有未完成向量化的文档后台补跑（最长 30 分钟），是否继续？', '提示', { type: 'warning' }).then(() => {
        this.$tools.asyncPost(this, this.$baseUrl.aiAgentKbRevector,
          agentBody({ id: this.currentKbId })).then((res) => {
          if (res.data.code == 0) this.$message({ type: 'success', message: res.data.msg || '已触发' })
        }).catch((err) => {
          if (err && err.isAxiosError) this.$message({ type: 'error', message: '请求失败，请稍后重试' })
        })
      }).catch(() => {})
    },

    // ===== 文档列表 =====
    loadDocs(silent) {
      if (!this.currentKbId) return
      if (!silent) this.loading = true
      const data = { page: this.currentPage, limit: this.pagesize, kb_id: this.currentKbId }
      if (this.queryForm.title) data.title = this.queryForm.title
      if (this.queryForm.status) data.status = this.queryForm.status
      const seq = ++this.docReqSeq // 守卫：切库/翻页/新查询发出后丢弃 in-flight 旧响应
      this.$tools.asyncPost(this, this.$baseUrl.aiAgentKbDocsList, agentBody(data)).then((res) => {
        if (seq !== this.docReqSeq) return
        if (res.data.code == 0) {
          this.tableData = res.data.data.data || []
          this.total = res.data.data.total || 0
          // 存在非终态文档保持轮询，全部终态自停（翻页/改筛选后会重新判断）
          if (this.tableData.some(d => FINAL_STATUS.indexOf(d.status) < 0)) this.startPolling()
          else this.stopPolling()
        }
        this.loading = false
      }).catch(() => {
        if (seq === this.docReqSeq) this.loading = false
      })
    },
    onSearch() {
      this.currentPage = 1
      this.loadDocs()
    },
    resetQuery() {
      this.queryForm = { title: '', status: '' }
      this.onSearch()
    },
    handleSizeChange(val) { this.pagesize = val; this.loadDocs() },
    handleCurrentChange(val) { this.currentPage = val; this.loadDocs() },

    // ===== 上传 =====
    chooseFile() {
      this.$refs.fileInput.click()
    },
    handleFileChange(e) {
      const file = e.target.files[0]
      e.target.value = '' // 复位以支持重复选择同一文件
      if (!file) return
      if (file.size > MAX_UPLOAD_SIZE) {
        return this.$message({ type: 'error', message: '文件不能超过 20MB' })
      }
      if (!UPLOAD_EXTS.some(ext => file.name.toLowerCase().endsWith(ext))) {
        return this.$message({ type: 'error', message: '仅支持 ' + UPLOAD_EXTS.join('/') })
      }
      this.doUpload(file)
    },
    doUpload(file) {
      const fd = new FormData()
      fd.append('kb_id', this.currentKbId)
      fd.append('file', file)
      this.uploading = true
      // multipart 不走 asyncPost；token 由 axios 拦截器注入
      // 必须显式声明 multipart：全局默认头是 application/json，axios 1.x 的默认 transformRequest
      // 检测到 application/json 会把 FormData 转成 JSON 提交（File 序列化成 {}，服务端收不到文件）。
      // 声明后 axios 原样发送 FormData，并在浏览器环境清掉该头，由浏览器补上 boundary
      this.$axios.post(this.$baseUrl.aiAgentKbDocsUpload, fd, {
        timeout: 120000,
        headers: { 'Content-Type': 'multipart/form-data' }
      }).then((res) => {
        if (res.data.code == 0) {
          this.$message({ type: 'success', message: '上传成功，等待解析' })
          this.currentPage = 1
          this.queryForm = { title: '', status: '' }
          this.loadDocs()
        }
        this.uploading = false
      }).catch((err) => {
        this.uploading = false
        // 业务错误拦截器已弹错，这里仅兜底网络层
        if (err && err.isAxiosError) this.$message({ type: 'error', message: '上传失败，请稍后重试' })
      })
    },

    // ===== 文档操作 =====
    handleRetry(row) {
      this.$tools.asyncPost(this, this.$baseUrl.aiAgentKbDocsRetry,
        agentBody({ doc_id: row.doc_id })).then((res) => {
        if (res.data.code == 0) {
          this.$message({ type: 'success', message: res.data.msg || '已重新入队' })
          this.loadDocs(true)
        }
      }).catch((err) => {
        if (err && err.isAxiosError) this.$message({ type: 'error', message: '请求失败，请稍后重试' })
      })
    },
    handleRevector(row) {
      this.$MessageBox.confirm('重新向量化为同步执行，大文档可能耗时数分钟，期间请勿关闭页面，是否继续？', '提示', { type: 'warning' }).then(() => {
        this.$set(row, 'revectoring', true)
        this.$tools.asyncPost(this, this.$baseUrl.aiAgentKbDocsRevector,
          agentBody({ doc_id: row.doc_id })).then((res) => {
          row.revectoring = false
          if (res.data.code == 0) {
            this.$message({ type: 'success', message: res.data.msg || '补跑完成' })
            this.loadDocs(true)
          }
        }).catch((err) => {
          row.revectoring = false
          if (err && err.isAxiosError) this.$message({ type: 'error', message: '请求失败，请稍后重试' })
        })
      }).catch(() => {})
    },
    handleDocDel(row) {
      this.$MessageBox.confirm('删除将移除文档及其全部派生数据（分块/向量/知识发现建议），确认删除？', '提示', { type: 'warning' }).then(() => {
        this.$tools.asyncPost(this, this.$baseUrl.aiAgentKbDocsDel,
          agentBody({ doc_id: row.doc_id })).then((res) => {
          if (res.data.code == 0) {
            this.$message({ type: 'success', message: '删除成功' })
            if (this.tableData.length === 1 && this.currentPage > 1) this.currentPage -= 1
            this.loadDocs()
          }
        }).catch((err) => {
          if (err && err.isAxiosError) this.$message({ type: 'error', message: '请求失败，请稍后重试' })
        })
      }).catch(() => {})
    },
    openDiscovery(row) {
      this.discoveryDoc = row
      this.discoveryVisible = true
    },

    // ===== 轮询 =====
    // 自递归 setTimeout 串行轮询：上一轮响应返回后再排下一轮，避免慢请求下 setInterval 并发堆积
    startPolling() {
      if (this.pollTimer || this._kbDead) return
      this.pollTimer = setTimeout(() => {
        this.pollTimer = null
        this.loadDocs(true) // 完成回调内按非终态续排下一轮
      }, 3000)
    },
    stopPolling() {
      if (this.pollTimer) {
        clearTimeout(this.pollTimer)
        this.pollTimer = null
      }
    },

    // 主入口切 Tab 激活时刷新
    onActivate() {
      this.loadKbs()
      if (this.currentKbId) this.loadDocs(true)
    },

    // ===== 展示工具 =====
    statusText(status) {
      return DOC_STATUS_TEXT[status] || status || '-'
    },
    statusTagType(row) {
      if (row.status === 'failed') return 'danger'
      if (row.status === 'done') return 'success'
      return 'warning'
    },
    // dirty（vector_state 非 ready 或为空）不是失败，单独小标签提示
    needRevector(row) {
      return row.status === 'done' && row.vector_state !== 'ready'
    },
    fmtSize(n) {
      if (n === null || n === undefined) return '-'
      if (n < 1024) return n + ' B'
      if (n < 1024 * 1024) return (n / 1024).toFixed(1) + ' KB'
      return (n / 1024 / 1024).toFixed(2) + ' MB'
    },
    fmtTime(s) {
      if (!s) return '-'
      return this.$tools.parserDateTime('datetime', s) || s.substring(0, 19).replace('T', ' ')
    }
  }
}
</script>

<style lang="less" scoped>
.kb_wrap {
  display: flex;
  gap: 16px;
  align-items: stretch;
  min-height: 400px;
}
.kb_side {
  width: 260px;
  flex-shrink: 0;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
}
.kb_side_head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 12px;
  border-bottom: 1px solid #ebeef5;
}
.kb_side_title {
  font-weight: bold;
}
.kb_list {
  flex: 1;
  overflow-y: auto;
  max-height: 640px;
  padding: 8px;
}
.kb_item {
  padding: 10px;
  border: 1px solid transparent;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  &:hover {
    background: #f5f7fa;
    .kb_item_ops { visibility: visible; }
  }
  &.active {
    background: #ecf5ff;
    border-color: #409eff;
    .kb_item_ops { visibility: visible; }
  }
}
.kb_item_body {
  min-width: 0;
}
.kb_item_name {
  font-weight: bold;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.kb_item_desc {
  font-size: 12px;
  color: #909399;
  margin-top: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.kb_item_ops {
  visibility: hidden;
  flex-shrink: 0;
  margin-left: 8px;
  i {
    margin-left: 6px;
    color: #909399;
    cursor: pointer;
    &:hover { color: #409eff; }
  }
}
.kb_empty {
  text-align: center;
  color: #909399;
  padding: 24px 0;
  font-size: 13px;
}
.kb_main {
  flex: 1;
  min-width: 0;
}
.toolbar {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 8px;
}
.kb_placeholder {
  border: 1px dashed #dcdfe6;
  border-radius: 4px;
  min-height: 300px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #909399;
  i {
    font-size: 40px;
    margin-bottom: 12px;
  }
}
.kb_file_input {
  display: none;
}
.danger_text {
  color: #f56c6c;
}
.dirty_tag {
  margin-left: 4px;
}
</style>
